export const isSessionStorageAvailable = () => {
    try {
        const testKey = 'sessionStorageTest';
        sessionStorage.setItem(testKey, '1');
        const isAvailable = sessionStorage.getItem(testKey) === '1';
        sessionStorage.removeItem(testKey);

        return isAvailable;
    } catch {
        return false;
    }
};

export const safeGetSessionStorageItem = (itemKey: string) => {
    try {
        return sessionStorage.getItem(itemKey);
    } catch {
        return null;
    }
};

export const safeSetSessionStorageItem = (itemKey: string, value: string) => {
    try {
        sessionStorage.setItem(itemKey, value);
    } catch {
        return undefined;
    }
};
